/**
 * ApiLoader – single minimal spinner during connect / long-running agent work.
 * Registers visibility so GlobalApiLoadingOverlay does not stack a second spinner.
 */

import { useEffect } from 'react';
import { useAgentContext } from '../../contexts/AgentContext';
import { setAgentLoadingOverlayActive } from '../../utils/loadingOverlayCoordinator';
import './api-loader.scss';

export default function ApiLoader() {
  const { loading, connecting } = useAgentContext();
  const showOverlay = loading || connecting;

  useEffect(() => {
    setAgentLoadingOverlayActive(showOverlay);
    return () => setAgentLoadingOverlayActive(false);
  }, [showOverlay]);

  if (!showOverlay) return null;

  return (
    <div
      className="api-loader-overlay api-loader-overlay--agent api-loader-overlay--minimal"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="api-loader-spinner-only" aria-hidden="true">
        <span className="api-loader-dot" />
      </div>
    </div>
  );
}
